import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Breadcrumb,
  BreadcrumbItem,
  Nav,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { parseUserInfo } from "../../utils/parseUtil";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetOptionsMutation } from "../../slices/commonApiSlice";
import { parseOptionsData } from "../../utils/parseOptionsData";
import { useGetForm14ForEmployeeMutation } from "../../slices/adminApiSlice";
import { Typeahead } from "react-bootstrap-typeahead";

const LeaveRegisterFormScreen14 = () => {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState(""); // New month state
  const [empType, setEmpType] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [reqXls, setReqXls] = useState("");
  const [activeType, setActiveType] = useState("0");  const [reportType, setReportType] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const { userInfo } = useSelector((state) => state.auth);
  const [getOptions, { isLoading: getOptionsLoading }] =
    useGetOptionsMutation();
  const [getForm14ForEmployee, { isLoading }] =
    useGetForm14ForEmployeeMutation();
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);

  const handleCheckboxChange = (e, type) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setLeaveTypes((prev) => [...prev, type]);
    } else {
      setLeaveTypes((prev) => prev.filter((t) => t !== type));
    }
  };

  // const validateLeaveTypes = () => {
  //     if (leaveTypes.length === 0) {
  //         toast.error("Please select at least one leave type.")
  //         return false
  //     }
  //     return true
  // }

  // const prepareFormData = () => {
  //     return {
  //         ReqChkCL: leaveTypes.includes("CL") ? 1 : 0,
  //         ReqChkSL: leaveTypes.includes("SL") ? 1 : 0,
  //         ReqChkEL: leaveTypes.includes("EL") ? 1 : 0,
  //         // Add other form data here
  //         reportType, // Example of integrating `reportType`
  //     }
  // }

  const handleReportType = (type) => {
    setReqXls(type);
  };

  const monthsOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }    setYearsOptions(options);
    setYear(currentYear.toString());
    
    // Set default month to current month
    const currentMonth = now.getMonth() + 1;
    setMonth(currentMonth.toString());

    const fetchOptions = async () => {
      try {
        const reqCompanyCode = userInfo[13]?.InfoField || "1";

        const formData = new FormData();
        formData.append("title", "GetEmployeeMasterDataList");
        formData.append("ReqCompanyCode", reqCompanyCode);

        const res = await getOptions(formData);

        const parsedOptions = parseUserInfo(res);
        const parsedData = parseOptionsData(parsedOptions);

        if (parsedData) {
          setEmployeeTypes(parsedData.employeeTypes);
        } else {
          toast.error("Failed to load employee types");
        }
      } catch (err) {
        console.error("Error fetching employee types:", err);
        toast.error("Error fetching employee types");
      }
    };

    fetchOptions();
  }, [getOptions, userInfo]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (leaveTypes.length === 0) {
    //     toast.error("Please select at least one leave type.")
    //     return
    // }

    const reqCompanyCode = userInfo[13]?.InfoField;
    const formData = new FormData();
    formData.append("title", "GetForm14ForEmployee");
    formData.append("ReqYear", year);
    formData.append("ReqMonth", reportType === "2" ? month : "");
    formData.append("ReqActiveType", activeType);
    formData.append("ReqEmpCode", empCode);
    formData.append("ReqEmpType", empType);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqRptType", reportType);
    formData.append("ReqXls", reqXls);

    // Append checkbox values (1 if selected, 0 if not)
    formData.append("ReqChkCL", leaveTypes.includes("CL") ? 1 : 0);
    formData.append("ReqChkSL", leaveTypes.includes("SL") ? 1 : 0);
    formData.append("ReqChkEL", leaveTypes.includes("EL") ? 1 : 0);

    console.log(Object.fromEntries(formData.entries()), "123");

    try {
      const res = await getForm14ForEmployee(formData);
      const parsedData = parseUserInfo(res);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;
          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;
          setPdfUrl(pdfUrl);
          setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <Nav.Link
            as={Link}
            to="/dashboard"
            className="text-success text-decoration-none"
          >
            Dashboard
          </Nav.Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Leave Register Form - 14 & 15</BreadcrumbItem>
      </Breadcrumb>
      <Container className="form-container">
        <h4 className=" text-center">Leave Register Form - 14 & 15</h4>
        <Form
          className="border p-4 rounded bg-light mb-4"
          onSubmit={handleSubmit}
        >
          <Row>
            <Col md={6}>
              <Form.Group controlId="year">
                <Form.Label>Year</Form.Label>
                <Form.Control
                  as="select"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  className="form-control-hover"
                  required
                >
                  {yearsOptions.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="empCode">
                <Form.Label>Employee Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Code"
                  value={empCode}
                  onChange={(e) => setEmpCode(e.target.value)}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="empType">
                <Form.Label>Employee Type</Form.Label>
                <Typeahead
                  id="empType-typeahead"
                  onChange={(selected) => setEmpType(selected[0])}
                  options={employeeTypes}
                  placeholder="Choose an employee type..."
                  selected={empType ? [empType] : []}
                  className="form-control-hover"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="activeType">
                <Form.Label>Active Type</Form.Label>
                <Form.Control
                  as="select"
                  value={activeType}
                  onChange={(e) => setActiveType(e.target.value)}
                  className="form-control-hover"
                  required
                >
                  <option value="0">All</option>
                  <option value="1">Active</option>
                  <option value="2">Dropped</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {reportType === "2" && (
            <Row>
              <Col md={12}>
                <Form.Group controlId="month">
                  <Form.Label>Month</Form.Label>                  <Form.Control
                    as="select"
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="form-control-hover"
                    required
                  >
                    {monthsOptions.map((month) => (
                      <option key={month.value} value={month.value}>
                        {month.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          )}

          {reportType === "2" && (
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Leave Types</Form.Label>
                  <div className="d-flex justify-content-around">
                    <Form.Check
                      type="checkbox"
                      id="checkCL"
                      name="leaveType"
                      label="CL"
                      value="CL"
                      checked={leaveTypes.includes("CL")}
                      onChange={(e) => handleCheckboxChange(e, "CL")}
                      className="mx-3"
                    />
                    <Form.Check
                      type="checkbox"
                      id="checkSL"
                      name="leaveType"
                      label="SL"
                      value="SL"
                      checked={leaveTypes.includes("SL")}
                      onChange={(e) => handleCheckboxChange(e, "SL")}
                      className="mx-3"
                    />
                    <Form.Check
                      type="checkbox"
                      id="checkEL"
                      name="leaveType"
                      label="EL"
                      value="EL"
                      checked={leaveTypes.includes("EL")}
                      onChange={(e) => handleCheckboxChange(e, "EL")}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          )}

          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label>Report Type</Form.Label>
                <div className="d-flex">
                  <Form.Check
                    type="radio"
                    id="reportType0"
                    name="reportType"
                    label="Leaves Form 14 (Yearly)"
                    value="0"
                    checked={reportType === "0"}
                    onChange={(e) => setReportType(e.target.value)}
                    className="mx-3"
                  />
                  <Form.Check
                    type="radio"
                    id="reportType1"
                    name="reportType"
                    label="Leaves Form 15 (Yearly)"
                    value="1"
                    checked={reportType === "1"}
                    onChange={(e) => setReportType(e.target.value)}
                  />
                  <Form.Check
                    type="radio"
                    id="reportType2"
                    name="reportType"
                    label="Leaves Summary (Yearly)"
                    value="2"
                    checked={reportType === "2"}
                    onChange={(e) => setReportType(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3 text-center">
            <Col>
              <Button
                type="submit"
                variant="danger"
                className="px-4"
                disabled={isLoading || getOptionsLoading}
              >
                {isLoading || getOptionsLoading ? "Loading..." : "PRINT PDF"}
              </Button>
            </Col>
            {reportType === "0" && (
              <Col>
                <Button
                  type="submit"
                  variant="success"
                  className="px-4"
                  disabled={isLoading || getOptionsLoading}
                  onClick={() => handleReportType(1)}
                >
                  {isLoading || getOptionsLoading
                    ? "Loading..."
                    : "PRINT EXCEL"}
                </Button>
              </Col>
            )}
          </Row>
        </Form>
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Yearly Leaves Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe
              src={pdfUrl}
              width="100%"
              height="500px"
              title="Yearly Leaves Report"
            ></iframe>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default LeaveRegisterFormScreen14;
